import { TYPE } from "../constant";
import { appAppsflyerEventFunc } from "./appEventFunc";

export const appsflyerEventName = {
  "on_boarding_viewed": "on_boarding-viewed",
  "mainpage_viewed": "mainpage_viewed",
  "af_login": "af_login",
  "af_complete_registration": "af_complete_registration",
  "test_start": "test_start",
  "test_completed": "test_completed",
  "learning_start": "learning_start",
  "learning_completed": "learning_completed",
  "camera_completed": "camera_completed",
  "af_content_view": "af_content_view",
  "check_incorrections": "check_incorrections",
  "progressreport_course": "progressreport_course",
  "progressreport_topic": "progressreport_topic",
  "premium_Page": "premium_Page",
  "mainvideo_click": "Mainvideo_click",
  "purchase_click": "purchase_click",
  "purchase_pop_btn_click": "purchase_pop_btn_click",
  "worksheet_mainclick": "worksheet_mainclick",
  "maingame_click": "maingame_click",
  "worksheet_courseclick": "worksheet_courseclick",
  "worksheet_topicclick": "worksheet_topicclick",
  "worksheet_resultclick": "worksheet_resultclick",
}

export function appsflyer(data) {
  const channelCode = localStorage.getItem('channel.code');
  if (!data.eventName || (channelCode !== TYPE.CHANNEL.GLOBAL01)) return;
  let result = null;
  switch (data.eventName) {
    case appsflyerEventName.on_boarding_viewed:
      result = on_boarding_viewed(data);
      break;
    case appsflyerEventName.mainpage_viewed:
      result = mainpage_viewed(data);
      break;
    case appsflyerEventName.af_login:
      result = af_login(data);
      break;
    case appsflyerEventName.af_complete_registration:
      result = af_complete_registration(data);
      break;
    case appsflyerEventName.test_start:
      result = test_start(data);
      break;
    case appsflyerEventName.test_completed:
      result = test_completed(data);
      break;
    case appsflyerEventName.learning_start:
      result = learning_start(data);
      break;
    case appsflyerEventName.learning_completed:
      result = learning_completed(data);
      break;
    case appsflyerEventName.camera_completed:
      result = camera_completed(data);
      break;
    case appsflyerEventName.af_content_view:
      result = af_content_view(data);
      break;
    case appsflyerEventName.check_incorrections:
      result = check_incorrections(data);
      break;
    case appsflyerEventName.progressreport_course:
      result = progressreport_course(data);
      break;
    case appsflyerEventName.progressreport_topic:
      result = progressreport_topic(data);
      break;
    case appsflyerEventName.premium_Page:
      result = premium_Page(data);
      break;
    case appsflyerEventName.mainvideo_click:
      result = mainvideo_click(data);
      break;
    case appsflyerEventName.purchase_click:
      result = purchase_click(data);
      break;
    case appsflyerEventName.purchase_pop_btn_click:
      result = purchase_pop_btn_click(data);
      break;
    case appsflyerEventName.worksheet_mainclick:
      result = worksheet_mainclick(data);
      break;
    case appsflyerEventName.maingame_click:
      result = maingame_click(data);
      break;
    case appsflyerEventName.worksheet_courseclick:
      result = worksheet_courseclick(data);
      break;
    case appsflyerEventName.worksheet_topicclick:
      result = worksheet_topicclick(data);
      break;
    case appsflyerEventName.worksheet_resultclick:
      result = worksheet_resultclick(data);
      break;
    default:
      break;
  }

  appAppsflyerEventFunc(`${result.eventName}+${result.eventParams ? JSON.stringify(result.eventParams) : '{}'}`);

}

function on_boarding_viewed(data) {
  return {
    eventName: appsflyerEventName.on_boarding_viewed,
    eventParams: null
  }
}

function mainpage_viewed(data) {
  return {
    eventName: appsflyerEventName.mainpage_viewed,
    eventParams: null
  }
}

function af_login(data) {
  return {
    eventName: appsflyerEventName.af_login,
    eventParams: null
  }
}

function af_complete_registration(data) {
  const { mkt_consent = '', af_rating_value = ''} = data.eventParams;
  return {
    eventName: appsflyerEventName.af_complete_registration,
    eventParams: { mkt_consent , af_rating_value }
  }
}

function test_start(data) {
  return {
    eventName: appsflyerEventName.test_start,
    eventParams: null
  }
};

function test_completed(data) {
  const { af_level = '' } = data.eventParams;
  return {
    eventName: appsflyerEventName.test_completed,
    eventParams: { af_level }
  }
}

function learning_start(data) {
  const {
    af_class = '',
    af_content_type = '',
    af_content_id = '',
  } = data.eventParams;

  return {
    eventName: appsflyerEventName.learning_start,
    eventParams: {
      af_class,
      af_content_type,
      af_content_id,
    }
  }
}

function learning_completed(data) {
  const {
    af_class = '',
    af_content_type = '',
    af_content_id = '',
  } = data.eventParams;
  return {
    eventName: appsflyerEventName.learning_completed,
    eventParams: {
      af_class,
      af_content_type,
      af_content_id,
    }
  }
}

function camera_completed(data) {
  const { af_success  = '' } = data.eventParams;
  return {
    eventName: appsflyerEventName.camera_completed,
    eventParams: {
      af_success
    }
  }
}

function af_content_view(data) {
  const {
    af_content_type = '',
    af_content_id  = '',
  } = data.eventParams;

  return {
    eventName: appsflyerEventName.af_content_view,
    eventParams: {
      af_content_type,
      af_content_id
    }
  }
}

function check_incorrections(data) {
  const {
    af_content_type = '',
    af_content_id = '',
  } = data.eventParams;
  return {
    eventName: appsflyerEventName.check_incorrections,
    eventParams: {
      af_content_type,
      af_content_id
    }
  }
}

function progressreport_course(data) {
  return {
    eventName: appsflyerEventName.progressreport_course,
    eventParams: null
  }
}

function progressreport_topic(data) {
  return {
    eventName: appsflyerEventName.progressreport_topic,
    eventParams: null
  }
}

function premium_Page(data) {
  return {
    eventName: appsflyerEventName.premium_Page,
    eventParams: null
  }
}

function mainvideo_click(data) {
  return {
    eventName: appsflyerEventName.mainvideo_click,
    eventParams: null
  }
}

function purchase_click(data) {
  return {
    eventName: appsflyerEventName.purchase_click,
    eventParams: null
  }
}

function purchase_pop_btn_click(data) {
  return {
    eventName: appsflyerEventName.purchase_pop_btn_click,
    eventParams: null
  }
}

function worksheet_mainclick(data) {
  return {
    eventName: appsflyerEventName.worksheet_mainclick,
    eventParams: null
  }
}

function maingame_click(data) {
  return {
    eventName: appsflyerEventName.maingame_click,
    eventParams: null
  }
}

function worksheet_courseclick(data) {
  const {
    af_content_type = '',
    af_content_id = '',
  } = data.eventParams;

  return {
    eventName: appsflyerEventName.worksheet_courseclick,
    eventParams: {
      af_content_type,
      af_content_id
    }
  }
}

function worksheet_topicclick(data) {
  const {
    af_content_type = '',
    af_content_id = '',
  } = data.eventParams;

  return {
    eventName: appsflyerEventName.worksheet_topicclick,
    eventParams: {
      af_content_type,
      af_content_id
    }
  }
}

function worksheet_resultclick(data) {
  const {
    af_content_type = '',
    af_content_id = '',
  } = data.eventParams;
  return {
    eventName: appsflyerEventName.worksheet_resultclick,
    eventParams: {
      af_content_type,
      af_content_id
    }
  }
}